import RegistrationForm from './RegistrationForm.jsx'

export default RegistrationForm
